export const OPEN_DIALOG = "DIALOGS::OPEN"
export const CLOSE_DIALOG = "DIALOGS::CLOSE"
export const SET_DIALOG_DATA = "DIALOGS::DATA::SET"
export const CLEAR_DIALOG_DATA = "DIALOGS::DATA::CLEAR"
export const UPDATE_DIALOG_DATA = "DIALOGS::DATA::UPDATE"
